import * as React from 'react'
import * as Styles from './MyPunchCoupon.style'
import MyPunchCouponType from './MyPunchCouponType'
import PunchCouponList from './components/PunchCouponList'
import {HttpServer} from '../../../services/server'
import { appBaseUrl } from '@/config'
import { globalWKLink, isTest } from '@/utils/tools'

declare const Session: any
interface IMyPunchCouponState {
    lectureList: MyPunchCouponType.ChannelsList[]
    couponList: MyPunchCouponType.CouponList[]
    hasLecture: boolean,
    hasCoupon: boolean,
    init: boolean
}

export const HasNothing = () => {
    const goHomePage = () => {
        window.location.assign('/')
    }
    return(
        <div className={Styles.nothingWrap}>
            <div className={Styles.nothingBox}>
                <div className={Styles.nothingImg}>
                    <img src={require('./assets/has_nothing.png')}/>
                </div>
                <div className={Styles.nothingTitle}>
                    还没有兑换记录哦
                </div>
                <div className={Styles.nothingSubTitle}>
                    记得保持每天签到，好礼拿不停！
                </div>
                <div className={Styles.nothingButton}>
                    <div className={Styles.nothingButtonText} onClick={goHomePage}>
                        返回首页，发现更多好课
                    </div>
                </div>
            </div>
        </div>
    )
}

export const ConvertLecture = ({lectureList}: {lectureList: MyPunchCouponType.ChannelsList[]}) => {
    const goChannel = (id: number) => {
        window.location.href = `${appBaseUrl}/channel2/` + id
    }
    if (lectureList && lectureList.length > 0) {
        return (
            <div>
                <div className={Styles.usedAwards}>
                    已兑换奖励
                </div>
                {lectureList && lectureList.length > 0 && lectureList.map((item: MyPunchCouponType.ChannelsList) => (
                    <div className={Styles.convertLectureListBox} onClick={() => goChannel(item.id)} key={item.id}>
                        <div className={Styles.convertLectureListItem}>
                            <div className={Styles.currentItemLeftBox}>
                                <div className={Styles.currentItemLeft}>
                                    <div className={Styles.currentItemImg}>
                                        <img src={item.cover_url}/>
                                    </div>
                                    <div className={Styles.currentItemRightBottomLeftContent}>
                                        <div className={Styles.studyNum}>
                                            <img src="https://static-cos.lycheer.net/picture/10490565_5ddfe21b03842fa68973218ec2737646.jpg" alt=""/>
                                            <span>{item.popular >= 10000 ? (item.popular / 10000).toFixed(2) + '万' : item.popular}</span>人
                                            </div>
                                        </div>
                                </div>
                            </div>
                            <div className={Styles.currentItemRight}>
                                <div className={Styles.currentItemRightTitle}>
                                    {item.title}
                                </div>
                            </div>
                            <div className={Styles.periodsNumber}>
                                已更新{item.expected_lectures}期
                            </div>
                            <div className={Styles.currentItemRightContainer}>
                                <div className={Styles.currentItemRightBottom}>
                                    <div>
                                        立即学习
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>))
                }
            </div>)
    } else {
        return null
    }
}

export default class MyPunchCoupon extends React.Component <IMyPunchCouponState> {
    public state: IMyPunchCouponState = {
        lectureList: [],
        couponList: [],
        hasLecture: false,
        hasCoupon: true,
        init: false
    }
    public async componentDidMount() {
        // 初始化分享
        if (Session.weixinApi) {

            const shareData = {
                title: '连续签到好礼拿不停',
                desc: '成长在于累积，快来和我一起签到学习！',
                link: `${appBaseUrl}/homepage/punch`,
                imgUrl: 'https://static-cos.lycheer.net/picture/8173011_2c2209ae7abd04b1a62a65d75ce54a2f.jpg-picmsg420'
            }

            const timeShareData = {
                ...shareData,
                link: `${globalWKLink.share}/punch`
            }

            Session.weixinApi.wxShare([shareData, timeShareData])
        }

        const getUsedAwardsRes = await HttpServer.getUsedAwards()
        const getUnusedAwardsRes = await HttpServer.getUnusedAwards()

        if (getUsedAwardsRes.data.data.channels.length === 0 && getUnusedAwardsRes.data.data.awards.length === 0) {
            this.setState({
                hasCoupon: false
            })
        }

        if (getUnusedAwardsRes.data.code === 0 ) {
            this.setState({
                couponList: getUnusedAwardsRes.data.data.awards,
                init: true
            })
        }

        if (getUsedAwardsRes.data.code === 0) {
            this.setState({
                lectureList: getUsedAwardsRes.data.data.channels,
                init: true
            })
        }
    }

    public goMyCouponPage = (item: MyPunchCouponType.CouponList) => {
        if (item.status === 'deadline') {
            return
        } else {
            if (item.bag_id) {
                if (!item.used) {
                    if (isTest()) {
                       window.location.href = `https://dbg.lizhiweike.com/coupons-bag/coupon?bagid=${item.bag_id}`
                    } else if (window.location.host === 'm1.lizhiweike.com') {
                        window.location.href = `https://m1.lizhiweike.com/coupons-bag/coupon?bagid=${item.bag_id}`
                    } else {
                        window.location.href = `${globalWKLink.wk}/coupons-bag/coupon?bagid=${item.bag_id}`
                    }
                }
            } else {
                window.location.assign(`https://weike.fm/v2RYQ3`)
            }
        }
    }

    public render() {
        if (!this.state.init) {
            return null
        }
        return (
            <div className={Styles.main}>
                {this.state.hasCoupon ?
                    <PunchCouponList couponList={this.state.couponList} goMyCouponPage={this.goMyCouponPage}/>
                    :
                    <HasNothing/>
                }
                <ConvertLecture lectureList={this.state.lectureList}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Punch/MyPunchCoupon/MyPunchCoupon.tsx